import Header from '../components/Header';
import * as locCon from '../LocalConstants';
import * as libCon from '../community-hats-js-library/Constants';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { SimpleCopyField, SimpleCopyFieldFromATO } from '../elements/SimpleStoreCopyField';

import { setStoredValue } from '../hooks/StoreHooks';
import CustomButton from '../elements/CustomButton';

import { useState } from 'react';

import { RefBundleDevices, RefHasGovees, RefHasKestrels } from '../hooks/BundleDeviceHooks';
import CheckboxGroup from '../elements/CheckboxGroup';
import SimpleLink from '../elements/SimpleLink';
import CompletionStatusText from '../elements/CompletionStatusText';
import { GoveeNameViewer } from '../components/SensorSetViewer';

export function ReInstallApplications() {
  // Language
  const i18n = RefContextLanguage();

  // Checks each brand
  const bundleHasGovees = RefHasGovees();
  const bundleHasKestrel = RefHasKestrels();
  const bundleDevices = RefBundleDevices();

  // For the SetUp
  const [allCheckboxes, setAllCheckboxes] = useState([]);

  const restartProcess = () => {
    setAllCheckboxes([]);
    setStoredValue(locCon.GA_SET_UP_GOOGLE_ACCOUNT, false);
    setStoredValue(locCon.FTB_DOWNLOAD_APPLICATION, false);
    setStoredValue(locCon.FTB_CREATE_NEW_ACCOUNT, false);
    setStoredValue(locCon.FTB_SET_TIME_ZONE, false);
    setStoredValue(locCon.FTB_SET_UP_DEVICE, false);

    setStoredValue(locCon.TA_SET_UP_TRACKER_APP, false);
    setStoredValue(locCon.TA_DOWNLOAD_TACKER_APP, false);
    setStoredValue(locCon.TA_LOCATION_PERMISSIONS, false);
    setStoredValue(locCon.TA_GET_PHONE_SERIAL, false);
    setStoredValue(locCon.TA_TURN_ON_LOCATION, false);
    setStoredValue(locCon.TA_TURN_ON_BLUETOOTH, false);
    setStoredValue(locCon.TA_ACTIVATE_TRACKING, false);

    setStoredValue(locCon.SUG_SET_UP_SENSOR, false);
    setStoredValue(locCon.SUG_DOWNLOAD_APP, false);
    setStoredValue(locCon.SUG_CREATE_ACCOUNT, false);
    setStoredValue(locCon.SUG_ADD_DEVICE_TO_APP, false);

    setStoredValue(locCon.SUK_SET_UP_SENSOR, false);
    setStoredValue(locCon.SUK_DOWNLOAD_APP, false);
    setStoredValue(locCon.SUK_ADD_DEVICE_TO_APP, false);
    setStoredValue(locCon.SUK_DISABLE_AUTOCONNECT, false);
    setStoredValue(locCon.SUK_SET_LOG_INTERVAL, false);

    setStoredValue(locCon.GAF_GROUP_APPS_IN_FOLDER, false);
  };

  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={false} hideTitle={true} />
        <CustomText type={locCon.MODULE_TITLE_TEXT}>{i18n.t('reInstallApplications')}</CustomText>
        <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('stepsToReInstallApplications')}</CustomText>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => restartProcess()}>
          {i18n.t('restartProcess')}
        </CustomButton>

        <div className="horizontalLine" />

        <div className="verticalSection">
          {/* Google Account*/}
          <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('googleAccount')}</CustomText>
          <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('googleAccountReDeployText')}</CustomText>
          <CheckboxGroup
            disableInfoLink={true}
            mainCheckbox={{
              [libCon.ID]: locCon.GA_SET_UP_GOOGLE_ACCOUNT,
              [libCon.TEXT]: i18n.t('loginToGoogleAccount'),
              [libCon.CONTAINER]: (
                <div>
                  <SimpleCopyFieldFromATO
                    atoId={locCon.AT_OBJECT_EMAIL_ACCOUNT}
                    fieldId={libCon.ATF_EMAIL}
                    title={i18n.t('goveeEmail')}
                    processFunction={(val) => (val === null || val === undefined ? null : val)}
                  />
                  <SimpleCopyFieldFromATO
                    atoId={locCon.AT_OBJECT_EMAIL_ACCOUNT}
                    fieldId={libCon.ATF_GOVEE_PASSWORD}
                    title={i18n.t('goveePassword')}
                    onCopyCleanUp={() => setStoredValue(locCon.SUG_CREATE_ACCOUNT, true)}
                  />
                </div>
              ),
            }}
          />
          <div className="horizontalLine" />

          {/* Fitbit set up */}
          <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('fitBitApplication')}</CustomText>
          <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('fitBitRedeployApplicationText')}</CustomText>
          <CheckboxGroup
            mainCheckbox={{
              [libCon.ID]: locCon.FTB_DOWNLOAD_APPLICATION,
              [libCon.TEXT]: i18n.t('downloadFitbitApp'),
            }}
          />
          <CheckboxGroup
            mainCheckbox={{
              [libCon.ID]: locCon.FTB_CREATE_NEW_ACCOUNT,
              [libCon.TEXT]: i18n.t('lognWithGoogleAccount'),
            }}
          />
          <CheckboxGroup
            mainCheckbox={{
              [libCon.ID]: locCon.FTB_SET_TIME_ZONE,
              [libCon.TEXT]: i18n.t('setTimeZone'),
              [libCon.CONTAINER]: <SimpleCopyField title={i18n.t('fitbitTimeZone')} value={locCon.FITBIT_TIME_ZONE} />,
            }}
          />
          <CheckboxGroup
            mainCheckbox={{ [libCon.ID]: locCon.FTB_SET_UP_DEVICE, [libCon.TEXT]: i18n.t('setUpWearableDevice') }}
          />

          <div className="horizontalLine" />

          {/* Location Tracker App*/}
          <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('locationTrackerApp')}</CustomText>
          <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('locationTrackerAppText')}</CustomText>
          <CheckboxGroup
            mainCheckbox={{
              [libCon.ID]: locCon.TA_SET_UP_TRACKER_APP,
              [libCon.TEXT]: i18n.t('setUpLocationTrackerApp'),
            }}
            checkBoxArray={[
              { [libCon.ID]: locCon.TA_DOWNLOAD_TACKER_APP, [libCon.TEXT]: i18n.t('downloadAndInstallApplication') },
              { [libCon.ID]: locCon.TA_LOCATION_PERMISSIONS, [libCon.TEXT]: i18n.t('givePermissions') },
              {
                [libCon.ID]: locCon.TA_GET_PHONE_SERIAL,
                [libCon.TEXT]: i18n.t('enterPhonesSerialNumber'),
                [libCon.CONTAINER]: (
                  <SimpleCopyFieldFromATO
                    atoId={locCon.AT_OBJECT_PHONE}
                    fieldId={libCon.ATF_SERIAL}
                    title={i18n.t('phoneSerialNumber')}
                  />
                ),
              },
              { [libCon.ID]: locCon.TA_TURN_ON_LOCATION, [libCon.TEXT]: i18n.t('turnOnLocation') },
              { [libCon.ID]: locCon.TA_TURN_ON_BLUETOOTH, [libCon.TEXT]: i18n.t('turnOnBluetooth') },
              { [libCon.ID]: locCon.TA_ACTIVATE_TRACKING, [libCon.TEXT]: i18n.t('activateTracking') },
            ]}
          />
          <div className="horizontalLine" />

          {/* Sensor Setup*/}
          {/* Govee*/}
          {bundleHasGovees ? (
            <>
              <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('setUpGovees')}</CustomText>
              <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('GoveeRedeploySensorText')}</CustomText>
              <CheckboxGroup
                mainCheckbox={{ [libCon.ID]: locCon.SUG_SET_UP_SENSOR, [libCon.TEXT]: i18n.t('setUpGovees') }}
                checkBoxArray={[
                  {
                    [libCon.ID]: locCon.SUG_DOWNLOAD_APP,
                    [libCon.TEXT]: i18n.t('downloadGoveeApp'),
                    [libCon.CONTAINER]: (
                      <div>
                        <SimpleLink
                          text={i18n.t('goveeApp')}
                          link={'https://play.google.com/store/apps/details?id=com.govee.home&hl=en&gl=US'}
                          onClickCleanup={() => setStoredValue(locCon.SUG_DOWNLOAD_APP, true)}
                        />
                      </div>
                    ),
                  },
                  {
                    [libCon.ID]: locCon.SUG_CREATE_ACCOUNT,
                    [libCon.TEXT]: i18n.t('loginGoveeAccount'),
                    [libCon.CONTAINER]: (
                      <div>
                        <SimpleCopyFieldFromATO
                          atoId={locCon.AT_OBJECT_EMAIL_ACCOUNT}
                          fieldId={libCon.ATF_EMAIL}
                          title={i18n.t('goveeEmail')}
                          processFunction={(val) => (val === null || val === undefined ? null : val)}
                        />
                        <SimpleCopyFieldFromATO
                          atoId={locCon.AT_OBJECT_EMAIL_ACCOUNT}
                          fieldId={libCon.ATF_GOVEE_PASSWORD}
                          title={i18n.t('goveePassword')}
                          onCopyCleanUp={() => setStoredValue(locCon.SUG_CREATE_ACCOUNT, true)}
                        />
                      </div>
                    ),
                  },
                  {
                    [libCon.ID]: locCon.SUG_ADD_DEVICE_TO_APP,
                    [libCon.TEXT]: i18n.t('addSensorsToApp'),
                    [libCon.CONTAINER]: (
                      <div className="verticalSection">
                        <CustomText type={locCon.INFO_TEXT}>{i18n.t('nameGoveeSensors')}</CustomText>
                        {bundleDevices
                          .filter((s) => s[libCon.FIELDS][libCon.ATF_BRAND] === libCon.GOVEE)
                          .map((s, i) => (
                            <>
                              <SimpleCopyField
                                key={`${s[libCon.FIELDS][libCon.ATF_SERIAL]}_${i}`}
                                value={s[libCon.FIELDS][libCon.ATF_SERIAL]}
                              />

                              <GoveeNameViewer
                                model={s[libCon.FIELDS][libCon.ATF_MODEL]}
                                mac={s[libCon.FIELDS][libCon.ATF_BLUETOOTH_MAC]}
                              />
                            </>
                          ))}
                      </div>
                    ),
                  },
                ]}
              />
              <div className="horizontalLine" />
            </>
          ) : (
            <div></div>
          )}

          {/* Kestrel*/}
          {bundleHasKestrel ? (
            <>
              <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('setUpKestrel')}</CustomText>
              <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('KestrelSetUpSensorText')}</CustomText>

              <CheckboxGroup
                mainCheckbox={{ [libCon.ID]: locCon.SUK_SET_UP_SENSOR, [libCon.TEXT]: i18n.t('setUpKestrel') }}
                checkBoxArray={[
                  {
                    [libCon.ID]: locCon.SUK_DOWNLOAD_APP,
                    [libCon.TEXT]: i18n.t('downloadSensorApp'),
                    [libCon.CONTAINER]: (
                      <div>
                        <SimpleLink
                          text={i18n.t('kestrelApp')}
                          link={'https://play.google.com/store/apps/details?id=com.kestrelinstruments.kdex&hl=en&gl=US'}
                          onClickCleanup={() => setStoredValue(locCon.SUK_DOWNLOAD_APP, true)}
                        />
                      </div>
                    ),
                  },
                  {
                    [libCon.ID]: locCon.SUK_ADD_DEVICE_TO_APP,
                    [libCon.TEXT]: i18n.t('addSensorToApp'),
                  },
                  {
                    [libCon.ID]: locCon.SUK_DISABLE_AUTOCONNECT,
                    [libCon.TEXT]: i18n.t('disableAutoConnect'),
                  },
                  {
                    [libCon.ID]: locCon.SUK_SET_LOG_INTERVAL,
                    [libCon.TEXT]: i18n.t('setLogInterval'),
                  },
                ]}
              />
              <div className="horizontalLine" />
            </>
          ) : (
            <div></div>
          )}

          {/* Group in folder */}
          <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('groupInFolder')}</CustomText>
          <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('groupInFolderText')}</CustomText>
          <CheckboxGroup
            mainCheckbox={{
              [libCon.ID]: locCon.GAF_GROUP_APPS_IN_FOLDER,
              [libCon.TEXT]: i18n.t('groupInFolderLong'),
            }}
          />
          <div className="horizontalLine" />

          <CompletionStatusText checkBoxIds={allCheckboxes} />

          <div className="horizontalLine" />
        </div>
      </div>
    </div>
  );
}

export default ReInstallApplications;
